"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingPage = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
require("./index.scss");
const className = 'loading-page';
const LoadingPage = (props) => {
    const { isLoading, loadingMessage, hideLoader } = props;
    const loadingOverlayProps = {
        isLoading: true,
        loadingMessage,
        hideLoader,
        modificators: 'background-none',
    };
    if (!isLoading)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(__1.LoadingOverlay, { ...loadingOverlayProps },
            react_1.default.createElement("div", { className: `${className}__block` }))));
};
exports.LoadingPage = LoadingPage;
//# sourceMappingURL=index.js.map